import { Checkbox, Col, Form, Input, Row } from 'antd'
import { CheckboxChangeEvent } from 'antd/es/checkbox'
import { FormInstance } from 'antd/lib'
import { useState } from 'react'

import { requiredRules } from 'src/app-constants'
import { Text } from 'src/components'
import { useLocales } from 'src/locales'

type Props = {
  form: FormInstance
  isPrimary: boolean
}

export const ConsultationFormGenitalSection = ({ form, isPrimary }: Props) => {
  const { t } = useLocales()

  const [isOtherChecked, setIsOtherChecked] = useState(false)

  const onOtherChange = (e: CheckboxChangeEvent) => {
    const value = e.target.checked

    setIsOtherChecked(value)

    form.setFieldsValue({
      form: {
        physicalExaminationSection: {
          genitalAnalRegionAssessment: {
            hasOtherPathologies: {
              isSelected: value,
              value: undefined
            }
          }
        }
      }
    })
  }

  return (
    <Col span={24}>
      <Text>
        {isPrimary ? '26.' : '21.'} {t('consultation_form.genital.title')}
      </Text>

      <Row gutter={[16, 16]} className="mt-16">
        <Col span={8}>
          <Form.Item
            name={[
              'form',
              'physicalExaminationSection',
              'genitalAnalRegionAssessment',
              'hasHerpesSimplex'
            ]}
            valuePropName="checked"
          >
            <Checkbox>
              {t('consultation_form.genital.hasHerpesSimplex')}
            </Checkbox>
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item
            name={[
              'form',
              'physicalExaminationSection',
              'genitalAnalRegionAssessment',
              'hasPrimarySyphilis'
            ]}
            valuePropName="checked"
          >
            <Checkbox>
              {t('consultation_form.genital.hasPrimarySyphilis')}
            </Checkbox>
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item
            name={[
              'form',
              'physicalExaminationSection',
              'genitalAnalRegionAssessment',
              'hasCondylomas'
            ]}
            valuePropName="checked"
          >
            <Checkbox>{t('consultation_form.genital.hasCondylomas')}</Checkbox>
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item
            name={[
              'form',
              'physicalExaminationSection',
              'genitalAnalRegionAssessment',
              'hasOtherPathologies',
              'isSelected'
            ]}
            valuePropName="checked"
          >
            <Checkbox onChange={onOtherChange}>
              {t('consultation_form.genital.hasOtherPathologies')}
            </Checkbox>
          </Form.Item>
        </Col>

        {isOtherChecked && (
          <Col span={16}>
            <Form.Item
              name={[
                'form',
                'physicalExaminationSection',
                'genitalAnalRegionAssessment',
                'hasOtherPathologies',
                'value'
              ]}
              rules={requiredRules}
            >
              <Input.TextArea placeholder={t('consultation_form.to_specify')} />
            </Form.Item>
          </Col>
        )}
      </Row>
    </Col>
  )
}
